import React, {useState} from "react";

import {Button, Tooltip} from "antd";
import {FilterOutlined} from "@ant-design/icons";

import FilterModal from "./FilterModal";
import {COLORS} from "./PoolSupporter";
import {LegendWrapper, LegendItem, ColorBox, LegendList} from "./PoolSupporter.styles";

const Legend = ({
    supporters,
    supportings,
    hiddenSupporters,
    hiddenSupportings,
    onSupportersChange,
    onSupportingsChange,
    showSelf,
    onShowSelfChange,
    showUnknown,
    onShowUnknownChange,
    selectedCategory,
    onCategorySelect
}) => {
    const [filterModalVisible, setFilterModalVisible] = useState(false);

    const activeSupporters = supporters?.filter(s => s.isActive && s.supporterPool?._id);
    const activeSupportings = supportings?.filter(s => s.isActive && s.pool?._id);

    const hasBothCategory = activeSupporters.some(supporter =>
        activeSupportings.some(supporting => supporting.pool?._id === supporter.supporterPool?._id)
    );

    const CATEGORIES = [
        {key: "own", color: COLORS.OWN_POOL, label: "Seçili Havuz"},
        {key: "supported", color: COLORS.SUPPORTED_POOL, label: "Destek Alınan Havuzlar"},
        {key: "supporting", color: COLORS.SUPPORTING_POOL, label: "Destek Verilen Havuzlar"},
        ...(hasBothCategory
            ? [{key: "both", color: COLORS.BOTH_SUPPORTING_AND_SUPPORTED, label: "Destek Alınan ve Verilen Havuzlar"}]
            : []),
        {key: "unknown", color: "#ccc", label: "Tanımsız Havuzlar"}
    ];

    const isFiltered =
        (hiddenSupporters && hiddenSupporters.length > 0) ||
        (hiddenSupportings && hiddenSupportings.length > 0) ||
        !showSelf ||
        !showUnknown;

    return (
        <LegendWrapper>
            <LegendList>
                {CATEGORIES.map(cat => (
                    <LegendItem
                        key={cat.key}
                        style={{
                            cursor: "pointer",
                            fontWeight: selectedCategory === cat.key ? "bold" : "normal",
                            opacity: selectedCategory && selectedCategory !== cat.key ? 0.5 : 1
                        }}
                        onClick={() =>
                            onCategorySelect &&
                            onCategorySelect(selectedCategory === cat.key ? null : cat.key)
                        }
                    >
                        <ColorBox color={cat.color} />
                        <span>{cat.label}</span>
                    </LegendItem>
                ))}
            </LegendList>
            <Tooltip title="Havuz Filtreleri">
                <Button type="link" onClick={() => setFilterModalVisible(true)}>
                    <FilterOutlined style={{marginRight: "2px"}} />
                    <span style={{position: "relative"}}>
                        Haritayı Filtrele
                        {isFiltered && (
                            <span
                                style={{
                                    position: "absolute",
                                    width: "6px",
                                    height: "6px",
                                    backgroundColor: "red",
                                    borderRadius: "50%",
                                    top: "2px",
                                    left: "calc(100% + 3px)"
                                }}
                            />
                        )}
                    </span>
                </Button>
            </Tooltip>
            <FilterModal
                visible={filterModalVisible}
                onCancel={() => setFilterModalVisible(false)}
                supporters={supporters}
                supportings={supportings}
                hiddenSupporters={hiddenSupporters}
                hiddenSupportings={hiddenSupportings}
                onSupportersChange={onSupportersChange}
                onSupportingsChange={onSupportingsChange}
                showSelf={showSelf}
                onShowSelfChange={onShowSelfChange}
                showUnknown={showUnknown}
                onShowUnknownChange={onShowUnknownChange}
            />
        </LegendWrapper>
    );
};

export default Legend;
